import { invoke } from "@tauri-apps/api/core";
import { listen, type UnlistenFn } from "@tauri-apps/api/event";
import type { DriveInfo } from "@/types";
import { isTauri } from "@/utils";

/** One-shot snapshot of currently mounted removable drives. */
export async function listRemovableDrives(): Promise<DriveInfo[]> {
  if (!isTauri()) return [];
  return invoke<DriveInfo[]>("list_removable_drives");
}

/** Extends the native `fs` plugin's scope to a drive's root. Must succeed
 * before any `plugin-fs`/`plugin-sql` call touches that path. */
export async function allowDriveScope(path: string): Promise<void> {
  if (!isTauri()) return;
  await invoke("allow_drive_scope", { path });
}

export function onDriveConnected(handler: (info: DriveInfo) => void): Promise<UnlistenFn> {
  return listen<DriveInfo>("drive://connected", (event) => handler(event.payload));
}

export function onDriveChanged(handler: (info: DriveInfo) => void): Promise<UnlistenFn> {
  return listen<DriveInfo>("drive://changed", (event) => handler(event.payload));
}

export function onDriveDisconnected(handler: (mountPoint: string) => void): Promise<UnlistenFn> {
  return listen<string>("drive://disconnected", (event) => handler(event.payload));
}
